import { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Benchmark, FieldModel } from '@cibo/core'
import { Chip, IconButton, Stack, Typography, chipClasses } from '@mui/material'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import {
  BenchmarkStatusModalStateDialogActions,
  useBenchmarkModal,
} from './BenchmarkStatusModalProvider'
import { statusColor, statusIcon } from './benchmarkStyles'

interface Props {
  benchmark: Benchmark
  fieldModel: FieldModel
  programId: string
  DialogActions?: BenchmarkStatusModalStateDialogActions
}

export const BenchmarkStatusChip = ({ benchmark, fieldModel, programId, DialogActions }: Props) => {
  const { t } = useTranslation('@cibo/programs/BenchmarkStatus')
  const { showBenchmarkModal } = useBenchmarkModal()

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    showBenchmarkModal(programId, benchmark, fieldModel.resourceId, DialogActions)
  }

  const benchmarkStatus = fieldModel.getBenchmarkStatus(programId, benchmark)
  const status = benchmarkStatus?.status

  if (!status) {
    return <Typography>--</Typography>
  }

  return (
    <div
      onClick={event => {
        event.stopPropagation()
      }}
    >
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Chip
          size="small"
          color={statusColor[status]}
          icon={statusIcon[status]}
          label={t(status, { context: benchmark })}
          sx={{
            [`& .${chipClasses.icon}`]: {
              color: 'white',
            },
            [`& .${chipClasses.label}`]: {
              color: 'white',
            },
          }}
        />
        {['fail', 'incomplete'].includes(status) && (
          <IconButton onClick={handleClick} data-testid="benchmark-status-info-button">
            <HelpOutlineOutlinedIcon />
          </IconButton>
        )}
      </Stack>
    </div>
  )
}
